// @flow
import styled from 'styled-components';
import { p, mt } from 'styled-components-spacing';
import theme from '@theme';
import breakpoint from 'styled-components-breakpoint';

export const StyledWrapper = styled.div`

`;

export const StyledHeadlineSection = styled.h1`
  font-size: 30px;
  font-weight: bold;
  text-align: center;
  ${p(2)};
  ${props => props.videoTitle && `
    margin-top: 4rem;
  `}
  ${breakpoint('mobile', 'tablet')`
  font-size: 22px;
  `}
`;

export const StyledSubHeadlineSection = styled.h2`
  font-size: 25px;
  font-weight: bold;
  color: ${theme.colors.mediumGray};
  text-align: center;
  ${p(2)};
  ${breakpoint('mobile', 'tablet')`
  font-size: 18px;
  `}
`;

export const StyledComponentFlexWrapper = styled.div`
  display: block;
`;

export const StyledComponentFlexdiv = styled.div`
  width: 100%;
  ${mt(4)}
`;

export const StyledOuterModalWrapper = styled.div`
 display: ${({ modalState }) => (modalState ? 'block' : 'none')};
  width: 100%;
  height: 100vh;
  top: 0;
  left: 0;
  position: fixed;
  background: rgba(0, 0, 0, 0.7);

  ${breakpoint('mobile', 'desktop')`
    height:100%;
  `}
 

  ${({ modalState }) => {
    const show = `
    visibility: visible;
    z-index: 1001;
    opacity: 1;
    transition: all .1s ease-in-out;
  `;

    const hide = `
   visibility: hidden;
    opacity: 0;
    z-index: -1;
    transition: all .1s ease-in-out;
  `;
    if (modalState) {
      return show;
    }

    return hide;
  }}
`;

export const StyledModalWrapper = styled.div`
  padding: 20px;
  height: 85%;
  width: 85%;
  background-color: red;
  margin: 0;
  position: relative;
  top: 50%;
  left: 50%;

  ${({ modalState }) => {
    const show = `
    visibility: visible;
    transform: translate(-50%, -50%);
    z-index: 200;
    opacity: 1;
    transition: all .1s ease-in-out;
  `;

    const hide = `
    visibility: hidden;
    transform: translate(-40%, -50%);
    opacity: 0;
    z-index: -1;
    transition: all .1s ease-in-out;
  `;
    if (modalState) {
      return show;
    }

    return hide;
  }}

  ${breakpoint('mobile', 'desktop')`
   padding: 10px;
   height:50%;
   border-radius: 10px;
   background-color: white;
 `}

 ${breakpoint('tablet', 'desktop')`
   max-height: 75vh;
   width: 500px;
 `}

${breakpoint('desktop')`
    max-height: 95vh;
    border-radius: 10px;
    background-color: white;
  `}
`;

export const StyledCross = styled.div`
  height: 20px;
  width: 17px;
  float: right;
  padding-bottom: 5.5px;
  cursor: pointer;
  ${breakpoint('mobile', 'desktop')`
    width: 13px;
    padding-bottom: 1.5px;
  `}
`;

export const StyledIframe = styled.iframe`
  width:100%;
  height:94%;
  position: relative;
  ${breakpoint('mobile', 'desktop')`
    height:92%;
    width:100%;
  `}
`;

export const StyledBanner = styled.div`
  display: flex;
  padding:10px 35px;
  max-width: 1400px;
  margin: 0 auto;
  justify-content: space-evenly;
  ${breakpoint('mobile', 'desktop')`
    flex-direction:column;
    align-items:center;
    padding:0px;
  `}
  ${breakpoint('tablet', 'desktop')`
    ${mt(3)}
  `}
`;

export const StyledBannerMaxWidth = styled.div`
  background-color: rgb(229 245 234);
`;

export const StyledBannerDiv = styled.div`
  padding-left: 20px;
  flex: 0 0 60%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-around;
  ${breakpoint('mobile', 'desktop')`
    align-items:center;
    padding-left:0px;
  `}

`;
export const StyledBannerCurefy = styled.img`
  width: 100%;
  padding: 10px 0px;
  ${breakpoint('mobile', 'tablet')`
    padding:0px;
  `}
  ${breakpoint('tablet', 'desktop')`
   width:80%;
  `}
`;
export const StyledBannerText = styled.div`
  font-size: 35px;
  color: rgb(0 81 78);
  padding: 5px;
  font-weight: 700;
  line-height: 1.5;
  ${breakpoint('mobile', 'tablet')`
    text-align:center;
    font-size: 24px;
  `}
  ${breakpoint('tablet', 'desktop')`
    text-align:center;
    font-size: 30px;
  `}
`;

export const StyledWatchNow = styled.div`
cursor: pointer;
  padding: 20px 30px;
  text-decoration: none;
  background-color: rgb(0, 79, 79);
  color: rgb(212, 233, 222);
  border-radius: 8px;
  border: none;
  text-align: center;
  cursor: pointer;
  font-size: 22px;
  font-weight: 600;
  
  ${breakpoint('mobile', 'desktop')`
    display:none;
  `}
   ${breakpoint('tablet', 'desktop')`
    margin-top:15px;
    padding: 12px 30px;
    font-size: 20px;
  `}
`;

export const StyledImage = styled.div`
${breakpoint('tablet', 'desktop')`
    display:flex;
    justify-content:center;
  `}
`;

export const StyledWatchNowMobile = styled.div`
  ${breakpoint('mobile', 'desktop')`
    cursor: pointer;
    margin:20px 30px;
    padding: 12px 15px;
    text-decoration: none;
    background-color: rgb(0, 79, 79);
    color: rgb(212, 233, 222);
    border-radius: 8px;
    border: none;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
    font-weight: 800;
  `}
  ${breakpoint('desktop')`
    display: none;
  `}
`;
